import React, { Component } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Welcome from './welcome';
import Lottie from 'react-lottie';
import animationData from './assets/documentlottie.json';

dayjs.extend(utc);

const badStateReasonMap = {
  OUT_OF_LIKES: "You’ve run out of likes on Hinge ❌",
  ACCOUNT_IS_PAUSED: "Your Hinge account is paused ❌",
  ACCOUNT_IS_INACTIVE: "Your Hinge account is inactive ❌",
  ACCOUNT_SUBSCRIPTION_EXPIRED: "Your TheLoveGuru Subscription has expired ❌",
  ACCOUNT_SEEN_EVERYONE: "You’ve seen everyone in your filters ❌",
  TOO_MANY_PEOPLE_WAITING: "Too many people are waiting ❌",
  ACCOUNT_UNLINKED: "Your Hinge account is not linked ❌",
  ACCOUNT_IS_NOT_COMPLETE: "Your Hinge Profile is not complete ❌"
};

const titleSx = {
  fontSize: '29px',
  width: '100%',
  marginLeft: '0px',
  textAlign: 'center',
  color: 'white',
  '@media (max-width: 600px)': {
    width: '95%',
    marginLeft: '0px',
    fontSize: '21px',
  },
  '@media (max-width: 400px)': {
    width: '95%',
    marginLeft: '0px',
    fontSize: '19px',
  },
};

const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const tableStyle = {
  width: '100%',
  maxWidth: '400px',
  marginTop: '40px',
  margin: '40px auto 0 auto',
  marginRight: 'auto',
  color: 'white',
  borderSpacing: '0 20px',
  fontSize: '17px',
  display: 'table',
  tableLayout: 'fixed',
  '@media (max-width: 600px)': {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

const labelCell = {
  textAlign: 'left',
  paddingRight: '20px',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  width: '50%',
};

const valueCell = {
  textAlign: 'left',
  fontWeight: 'bold',
  verticalAlign: 'middle',
  wordBreak: 'break-word',
  width: '50%',
};

class UserReport extends Component {
  constructor(props) {
    super(props);
    this.state = { fadeIn: false };
  }

  componentDidMount() {
    this.triggerFadeIn();
  }

  triggerFadeIn = () => {
    this.setState({ fadeIn: false }, () => {
      setTimeout(() => this.setState({ fadeIn: true }), 10);
    });
  };

  getUtcDate = () => {
    const nowUtc = dayjs.utc();
    return nowUtc.format('YYYY-MM-DD');
  };

  getProfileMessage = (reason, isActive) => {
    if (!isActive) return badStateReasonMap["ACCOUNT_UNLINKED"];
    if (!reason || reason.trim() === "") return "Your profile is in a good state ✅";
    return badStateReasonMap[reason] || "Profile issue detected ❌";
  };

  render() {
    const { fadeIn } = this.state;
    const { userData } = this.props;
    if (!userData) return null;

    const dateLabel = this.getUtcDate();
    const profileState = this.getProfileMessage(userData.badStateReason, userData.isActive);

    return (
      <div style={{ width: '100%' }}>
        <div style={{ marginTop: '130px', opacity: fadeIn ? 1 : 0, transition: 'opacity 1s ease-in' }}>
          <Welcome sx={titleSx} text="Your Daily Report" />
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', opacity: fadeIn ? 1 : 0 }}>
          <Lottie options={lottieOptions} height={200} width={200} />
        </div>

        <table style={{ ...tableStyle, opacity: fadeIn ? 1 : 0, transition: 'opacity 1s ease-in' }}>
          <tbody>
            <tr>
              <td style={labelCell}>📅 Date:</td>
              <td style={valueCell}>{dateLabel} UTC</td>
            </tr>
            <tr>
              <td style={labelCell}>❤️ Liked So Far:</td>
              <td style={valueCell}>{userData.likedSoFar} / {userData.sendMaxLikes}</td>
            </tr>
            <tr>
              <td style={labelCell}>💬 Icebreakers So Far:</td>
              <td style={valueCell}>{userData.responsesSoFar} / {userData.sendMaxResponses}</td>
            </tr>
            <tr>
              <td style={labelCell}>🧠 Profile Status:</td>
              <td style={valueCell}>{profileState}</td>
            </tr>
          </tbody>
        </table>
        <div style={{ height: '150px' }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.user.userData,
});

export default connect(mapStateToProps)(UserReport);